import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FormGroup, Select } from 'components/common/form';

interface Props {
  disabled?: boolean;
  maxWidth?: number | string;
  type: 'course' | 'path' | 'calendar-event';
}

const CertificatesSelectTemplate = ({
  disabled = false,
  maxWidth = null,
  type
}: Props) => {
  const { messages, serverConfig } = useReduxState();

  const { data: templatesData } = useApiData({
    onlyIf: serverConfig.certificatesEnableSelection,
    url: `/admin/certificate-templates?type=${type}`
  });

  if (!templatesData?.templates || templatesData.templates.length < 1) {
    return null;
  }

  return (
    <FormGroup
      htmlFor="certificate-template-id"
      label={messages.siteCertificatesTemplate}
      style={{ marginBottom: 25 }}
      {...(maxWidth
        ? {
            maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth
          }
        : {})}
    >
      <Select
        disabled={disabled}
        field="CertificateTemplateId"
        id="certificate-template-id"
        options={[
          {
            label: messages.commonDefault,
            value: 0
          },
          ...(templatesData.templates || []).map((template) => ({
            label: template.title,
            value: template.id
          }))
        ]}
      />
    </FormGroup>
  );
};

export default CertificatesSelectTemplate;
